


const capitaliceWord =(word)=>{
    const response = word
    .toLowerCase()
    .replace(/\b\w/g, letra => letra.toUpperCase());
    return response
}


export {
    capitaliceWord
}